import { getFiGrowthBook } from '../lib/growthbook';

/**
 * The in-site bag and checkout, which replace the shop handoff.
 *
 * Read before GrowthBook has loaded this resolves false, which keeps the shop CTA -- the safe
 * default, since the shop serves the same offer and the bag cannot render without one.
 *
 * Lives here rather than in `RegisterChipV2` because both that module and `SuccessStepV2` need it,
 * and `RegisterChipV2` already imports `SuccessStepV2`.
 */
export function useInSiteCheckoutEnabled() {
  return getFiGrowthBook().getFeatureValue('nano-in-site-checkout', false);
}
